import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(public)/blog/BlogsPageClient.tsx");
